import { Directive, forwardRef, Input, OnChanges, SimpleChanges, Type } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

/**
 * Validates dropdown value is not empty or undefined
 * only if ValidateCondition is satisfied (set to true)
 */
@Directive({
  selector: '[tdWbConsolidatedAgreementsDropdownValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<ConsolidatedAgreementsFormsValidator> => ConsolidatedAgreementsFormsValidator),
    multi: true
  }],
  standalone: false
})
export class ConsolidatedAgreementsFormsValidator implements Validator, OnChanges {
  @Input() tdWbConsolidatedAgreementsDropdownValidator: unknown;
  @Input() tdWbValidateCondition: boolean;
  private _onChange: (changes: SimpleChanges) => void;

  validate(): ValidationErrors | null {
    if (this.tdWbValidateCondition &&
      (this.tdWbConsolidatedAgreementsDropdownValidator === undefined || this.tdWbConsolidatedAgreementsDropdownValidator === '')) {
      return { required: true };
    }
    return null;
  }

  registerOnValidatorChange(fn: (changes: SimpleChanges) => void): void {
    this._onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this._onChange !== undefined) {
      this._onChange(changes);
    }
  }
}
